import Tip, { TipProps } from "../../tips/Tip"

function HomeLibraryBlankSlateTip(props: Partial<TipProps>) {
  return (
    <Tip
      tip={{
        title: "Your Library",
        content:
          // "Your Library contains all the Paths you’ve participated in, even if you’re not currently focused on them."
          "Your Library is where you can keep track of paths you’ve Set Aside for later."
      }}
      icon="lightbulb-on"
      layout="default"
      colorScheme="dark"
      {...props}
    />
  )
}

export default HomeLibraryBlankSlateTip
